module.exports = __webpack_public_path__ + "img/组 189.7bae3b47.png";